module.exports = {
	illustrationEmptyStateAssistant:
		'/assets/images/illustrations/empty-state-assistant.svg',
	illustrationEmptyStateEvents:
		'/assets/images/illustrations/empty-state-events.svg',
	illustrationEmptyStateTasks:
		'/assets/images/illustrations/empty-state-tasks.svg',
};
